import { Site } from './site'

// TODO: generalize for all apps. Can this be broken out further
export type UserRole =
  | 'mybib'
  | 'mybibpro'
  | 'not_logged_in'
  | 'edu'
  | 'edu_admin'
  | 'edu_coppa' // Converted from a typed constant

export interface FetchUserResponse {
  user: {
    role: UserRole
    paidMember: boolean
    subscriptionType: string
    id: number
    first: string
    last: string
    email: string
    username: string
    encodedId: string
    affiliate?: string
    oauth?: {
      accessKey?: string
    }
  }
  oauth: {
    accessKey: string
    expiresAt: number
  }
  projectId: string
  jwt?: string
  chegg_uuid?: string
  coupon: string | null
  feedbackId: string
  access_token: string
  status?: 'in process' | 'not yet started' | 'complete'
  isLoading: boolean
  migration_id?: number
}

export interface User extends FetchUserResponse {
  exp: number
}

export interface CitationsJWT {
  readonly site: Site
  readonly client: string
  readonly email: string
  readonly cheggTokens: {
    readonly id_token?: string
    readonly access_token?: string
    readonly expires_in?: string
  }
  readonly user_role: string
  readonly paidMember: boolean
  readonly sessionId: string
  readonly cheggUserUuid: string
  readonly exp: number
}

export const CITATIONS_JWT_TYPE_ERROR = 'CITATIONS_JWT_TYPE_ERROR' as const
export const CITATIONS_JWT_NULL_CHEGG_TOKENS_ERROR = 'CITATIONS_JWT_NULL_CHEGG_TOKENS_ERROR' as const

export type CitationsJwtErrorType =
  | typeof CITATIONS_JWT_TYPE_ERROR
  | typeof CITATIONS_JWT_NULL_CHEGG_TOKENS_ERROR

export interface CitationsJwtError extends Error {
  type: CitationsJwtErrorType
}
/* eslint-disable */
export class CitationsJwtError extends Error {
  constructor(type: CitationsJwtErrorType, message: string) {
    super(message)

    // Set the prototype explicitly. More info here: https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, new.target.prototype)

    this.type = type
    this.message = `Invalid JWT: ${this.message}`
  }
}
